(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_request/wager.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_request/wager.js');

'use strict';

class WagerRequest {
  constructor(_ref) {
    let {
      sequenceNum = 0,
      voucher,
      fractionHolder,
      fraction,
      crc = 0,
      syndicateId,
      subscriptionId,
      voucherId,
      marketInfo,
      bagType = 0,
      bets = []
    } = _ref;
    this.request = {};
    if (sequenceNum) {
      this.request.sequenceNum = sequenceNum;
    }
    if (voucher) {
      this.request.voucher = voucher;
    }
    if (fractionHolder) {
      this.request.fractionHolder = fractionHolder;
    }
    if (fraction) {
      this.request.fraction = fraction;
    }
    if (crc) {
      this.request.crc = crc;
    }
    if (syndicateId) {
      this.request.syndicateId = syndicateId;
    }
    if (subscriptionId) {
      this.request.subscriptionId = subscriptionId;
    }
    if (voucherId) {
      this.request.voucherId = voucherId;
    }
    if (marketInfo) {
      this.request.marketInfo = marketInfo;
    }
    if (bagType) {
      this.request.bagType = bagType;
    }
    if (bets) {
      this.request.bets = bets;
    }
    return this.request;
  }
}
svs.tur.payment.api.jupiter.request.Wager = WagerRequest;

 })(window);